import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';

export const PresetsEditGeneralDialogSkeleton: React.FC = () => {
  return (
    <>
      <Box sx={{ display: 'grid', gap: '16px', gridTemplateColumns: '1fr 1fr' }}>
        <Skeleton height={40} variant="rounded" />
        <Skeleton height={40} variant="rounded" />
      </Box>
      <Skeleton height={40} sx={{ marginBottom: '4px' }} variant="rounded" />
      <Skeleton height={40} variant="rounded" />
    </>
  );
};
